import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { init, nativeShare } from '@ifeng-fe/container_content/common/client/utils/nativeShare';

class Share extends React.Component {
    static propTypes = {
        docData: PropTypes.object,
        sharePPX: PropTypes.string,
    };

    handleClick = e => {
        const { docData } = this.props;
        const config = {
            url: docData.pcUrl ? docData.pcUrl : '',
            title: docData.title ? docData.title : '',
            desc: docData.summary ? docData.summary : '',
            img:
                docData.imagesInContent && docData.imagesInContent[0] && docData.imagesInContent[0].url
                    ? docData.imagesInContent[0].url
                    : '',
            img_title: '',
            from: docData.source ? docData.docData : '',
            summary: docData.summary ? docData.summary : '',
        };
        const from = window.location.search.indexOf('?ch=qd_hw_fyp1') !== -1;
        const dataApp = e.currentTarget.attributes['data-app'].value;

        nativeShare(config, from, dataApp);

        e.stopPropagation();
    };

    handleWbClick = () => {};

    render() {
        const { sharePPX } = this.props;
        const type = init();

        return (
            <div className={styles.share_box}>
                <ul className={styles.share_items}>
                    {type === 'all' ? (
                        <React.Fragment>
                            <li data-app="weixin" className={styles.wx} onClick={this.handleClick} />
                            <li data-app="weixinFriend" className={styles.pyq} onClick={this.handleClick} />
                            <li data-app="sinaWeibo" className={styles.wb} onClick={this.handleClick} />
                            <li data-app="QQ" className={styles.qq} onClick={this.handleClick} />
                            <li data-app="QZone" className={styles.qqzone} onClick={this.handleClick} />
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <li data-app="sinaWeibo" className={styles.wb} onClick={this.handleClick} />
                            <li data-app="QZone" className={styles.qqzone} onClick={this.handleClick} />
                        </React.Fragment>
                    )}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(Share);
